module.exports = __webpack_public_path__ + "static/media/footer-bg-slogan.e02fb0a5.png";